import { render } from "./ModelsGrid.vue?vue&type=template&id=64bf2e79&scoped=true"
import script from "./ModelsGrid.vue?vue&type=script&lang=js"
export * from "./ModelsGrid.vue?vue&type=script&lang=js"

import "./ModelsGrid.vue?vue&type=style&index=0&id=64bf2e79&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64bf2e79"]])

export default __exports__